import store from '@/store'
import { QcqCommonGridItem, UiLanguageItem, UiLanguageList } from '@/types'
import { DetailResponse, DetailResponseItem } from '@/types/service-response'

export interface DetailItem {
  id: number
  code: string
  description: string
}

export class Detail {
  private constructor (
    readonly dataMap: Map<string, DetailItem>
  ) {}

  get commonGridData (): QcqCommonGridItem {
    const selectedUiLanguage: UiLanguageItem | undefined = store.state.selectedUiLanguage
    const value = this.dataMap.get(selectedUiLanguage!.code)

    const newItem: QcqCommonGridItem = {
      id: value!.id,
      code: value!.code,
      description: value!.description,
    }
    return newItem!
  }

  static createListFromResponse (responseData: DetailResponse): Array<Detail> {
    const detailList: Array<Detail> = []
    let result: Map<number, Array<DetailResponseItem>> = new Map()
    const languageList: UiLanguageList = store.state.uiLanguageList

    responseData.forEach((responseItem: DetailResponseItem) => {
      if (responseItem.SpracheID !== null) {
        if (!result.has(responseItem.DetailID)) {
          result.set(responseItem.DetailID, [responseItem])
        } else {
          result.get(responseItem.DetailID)!.push(responseItem)
        }
      }
    })

    result.forEach((responseItemArray: Array<DetailResponseItem>) => {
      let dataMap: Map<string, DetailItem> = new Map()

      responseItemArray.forEach((responseItem: DetailResponseItem) => {
        const languageItem = languageList.find((languageItem: UiLanguageItem) => languageItem.syzId === responseItem.SpracheID)
        if (languageItem) {
          let row: DetailItem = {
            id: responseItem.DetailID,
            code: responseItem.DetailCode,
            description: responseItem.DetailBezeichnung
          }
          dataMap.set(languageItem.code, row)
        }
      })
      detailList.push(new Detail(dataMap))
    })

    return detailList
  }
}